
import state from './moduleCoursesreportState.js'
import mutations from './moduleCoursesreportMutations'
import actions from './moduleCoursesreportActions'
import getters from './moduleCoursesreportGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
